module.exports = __webpack_public_path__ + "img/legend-pay-logo-mini copy.9196a0f2.svg";